import styles from "./radio.module.css";

type RadioProps = {
  label?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  allowDeselectNull?: boolean;
  onChange?: (value: string) => void;
  tabIndex?: number;
};

const RadioInput = ({
  label,
  className,
  name,
  value,
  checked,
  disabled,
  onChange,
  allowDeselectNull = false,
  tabIndex = undefined,
}: RadioProps) => {

  return (
    <label className={`${styles.customRadio} ${disabled ? "input-disabled" : ""}`} tabIndex={tabIndex}>
      <input
        className={className}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange?.(value)}
        onClick={() => { if(checked && allowDeselectNull) onChange?.(null); } }
      />
      <span className={styles.checkmark}></span>
      {label && label}
    </label>
  );
};

export default RadioInput;